// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { CloseIcon, Button, Text, LinkExternal } from '@pancakeswap/uikit';
import { useWeb3React } from '@web3-react/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import { getLockUpAddress } from 'utils/addressHelpers';
import { getContract } from 'utils/contractHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { setPidx } from 'store/IndexSlice';
import LoopIcon from '@mui/icons-material/Loop';

interface WithdrawModalProps {
    onClose: () => void;
    open: boolean;
    pool: any;
}

const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    // border-bottom: 1px solid #00FED9;
    display: flex;
    padding: 24px 24px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ModalBody = styled(Box)`
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    padding: 24px;
`

const ConfirmButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 2px solid red;
  border-radius: 16px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  /* line-height: 1.5; */
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px !important;
  padding: 0px 20px;
  width: 100%;
  background-color: transparent;
  color: white;
  margin-top: 24px;
  font-weight: 600;
  font-size: 20px;
  ${({ theme }) => theme.mediaQueries.xs} {
    height: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

const CloseButton = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    color: white;
    box-shadow: none;

`

const WithdrawModal: React.FunctionComponent<WithdrawModalProps> = ({
    open,
    onClose,
    pool

}) => {
    // console.log("first", pool)
    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    const [disabledbutton, setDisabledButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const pidx = useSelector((state: any) => state.Index.processidx);
    const emergencyReward = async (pooltype) => {
        if (account) {
            setLoading(true);
            try {
                let tx;
                if (pool.contractType === "lockup") {
                    const lockUpAddress = getLockUpAddress();
                    const lockUpContract = getContract(DrivenLockupABI, lockUpAddress, library.getSigner());
                    tx = await lockUpContract.emergencyWithdraw(pooltype);
                }
                await tx.wait();
                onClose();
                dispatch(setPidx(pidx + 1))
            } catch (err) {
                console.log(JSON.stringify(err))
            }
            setLoading(false);
        }
    }
    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        // left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                        left: { xl: '50%', lg: '50%', md: '50%', sm: '50%', xs: '50%' }
                    }}>
                    <Box sx={{
                        width: 'auto',
                        // py: 4,
                        background: '#1A3342',
                        // boxShadow: 'rgba(14, 14, 44, 0.1) 0px 20px 36px -8px, rgba(0, 0, 0, 0.05) 0px 1px 1px',
                        borderRadius: '32px',
                        maxWidth: '525px',
                        // minWidth:'380px',
                        minWidth: { xl: '730px', lg: '730px', md: '600px', sm: '600px', xs: '380px' },
                        maxHeight: '100vh',
                        zIndex: '100'
                        // minWidth: '500px'
                    }}>
                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        color: '#00FED9',
                                    }}>
                                    Emergency Withdraw
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>

                        <ModalBody>

                            <Text color='white' fontSize='16px' fontWeight={400} lineHeight={1.5} >
                                If you choose to withdraw your tokens, you will get an {pool.emergencyWithdrawFee}% tax on the amount that you staked and all your rewards will be canceled.
                            </Text>
                            <ConfirmButton onClick={() => emergencyReward(pool.stackType)} disabled={parseFloat(pool.user.pendingreward) > 0.0 ? loading : true}>
                                Confirm and Withdraw{loading && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}
                            </ConfirmButton>
                        </ModalBody>


                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default WithdrawModal;
